<template>
  <div class="main">
    <div class="queryResult">{{ $t('eVoucherPage.title') }}</div>
    <div class="content">
      <site-m class="chooseMDisplay" ref="sitem"></site-m>
      <shop-m class="chooseMDisplay" ref="shopm"></shop-m>
      <!-- style="flex: 1" -->
      <time-m
        class="timeMDisplay"
        @queryEvent="queryEvent"
        @exportExcel="exportExcel"
        ref="time"
      ></time-m>
    </div>
    <div class="queryResultTxt">{{ $t('eVoucherPage.queryResult') }}</div>
    <div v-if="$store.getters.get_notMobileView" class="list-style">
      <ul>
        <li>{{ $t('eVoucherPage.shopCol') }}</li>
        <li>{{ $t('eVoucherPage.locationCol') }}</li>
        <li>{{ $t('eVoucherPage.shopIdCol') }}</li>
        <li>{{ $t('eVoucherPage.eVoucherNameCol') }}</li>
        <li>{{ $t('eVoucherPage.referenceIdCol') }}</li>
        <li>{{ $t('eVoucherPage.transactionDateCol') }}</li>
        <li>{{ $t('eVoucherPage.faceValueCol') }}</li>
      </ul>
      <ul v-for="item in dataResult" :key="item.ShopId">
        <li>{{ item.shopName }}</li>
        <li>{{ item.shopLocation }}</li>
        <li>{{ item.locationCode }}</li>
        <li>{{ item.eVoucherName }}</li>
        <li>{{ item.referenceId }}</li>
        <li>{{ formatDate(item.activityDate) }}</li>
        <li>HK${{ item.consumption }}</li>
      </ul>
    </div>
    <div v-else class="list-style-mobile">
      <ul v-for="item in dataResult" :key="item.ShopId">
        <li>
          <span>{{ $t('eVoucherPage.shopCol') }}</span>
          <span>{{ item.shopName }}</span>
        </li>
        <li>
          <span>{{ $t('eVoucherPage.locationCol') }}</span>
          <span>{{ item.shopLocation }}</span>
        </li>
        <li>
          <span>{{ $t('eVoucherPage.shopIdCol') }}</span>
          <span>{{ item.eVoucherName }}</span>
        </li>
        <li>
          <span>{{ $t('eVoucherPage.eVoucherNameCol') }}</span>
          <span>{{ item.referenceId }} </span>
        </li>
        <li>
          <span>{{ $t('eVoucherPage.referenceIdCol') }}</span>
          <span> {{ item.referenceId }} </span>
        </li>
        <li>
          <span>{{ $t('eVoucherPage.transactionDateCol') }}</span>
          <span> {{ formatDate(item.activityDate) }} </span>
        </li>
        <li>
          <span>{{ $t('eVoucherPage.faceValueCol') }}</span>
          <span> HK${{ item.consumption }} </span>
        </li>
      </ul>
    </div>

    <div class="Pagination">
      <ul>
        {{
          $t('eVoucherPage.totalPages')
        }}
        {{
          totalPages
        }},
        {{
          $t('eVoucherPage.totalCount')
        }}
        {{
          totalCount
        }}
      </ul>
      <ul style="display: flex">
        <li>
          <span class="pageBtn" @click="search('home')">|&lt;</span>
          <span class="pageBtn" @click="search('previous')">&lt;</span>
        </li>
        <li>
          <span
            class="PageNumber"
            v-for="p in PageNumbers"
            :key="p"
            @click="search(p)"
            :class="{ pageBtn: p == currentPageIndex }"
            >{{ p }}</span
          >
        </li>
        <li>
          <span class="pageBtn" @click="search('next')">&gt;</span>
          <span class="pageBtn" @click="search('end')">&gt;|</span>
        </li>
      </ul>
    </div>
    <div class="footer">
      <span></span
      ><span
        >{{ $t('eVoucherPage.totalFaceValue') }} HK${{ TotalConsumption }}</span
      >
    </div>
    <div style="height: 20px"></div>
    <a-modal v-model:open="visible" :footer="null" :closable="false" width="340px">
      <div style="height: 340px">
        <div
          style="height: 80px; color: #646a80; cursor: pointer"
          @click="back"
        >
          &lt;{{ $t('common.back') }}
        </div>
        <div style="text-align: center">
          <img src="/Images/timeError.png" style="width: 140px" />
        </div>
        <div
          style="
            height: 80px;
            text-align: center;
            line-height: 80px;
            color: #646a80;
          "
        >
          {{ $t('eVoucherPage.dateOutOfRange') }}
        </div>
      </div>
    </a-modal>
  </div>
</template>
<style scoped>
.main {
  width: 100%;
  height: calc(100% - 100px);
  display: flex;
  flex-direction: column;
}
.content {
  margin: 0 auto;
  display: flex;
  width: 80%;
}

.list-style {
  flex: 1;
  margin: 0 auto;
  width: 80%;
}
.list-style ul {
  display: flex;
  /* background: #f5f5f5; */
  justify-content: space-around;
  height: 42px;
  align-items: center;
}
.list-style li {
  flex: 1;
  text-align: center;
}
.list-style ul:first-child {
  display: flex;
  background: #f5f5f5;
  justify-content: space-around;
  color: #3d4d6b;
  font-size: 15px;
  font-weight: 500;
  height: 42px;
  align-items: center;
  border-radius: 3px;
}

/* 奇数行的样式 */
.list-style ul:nth-child(odd) {
  background: #f5f5f5;
  border-radius: 3px;
}

.queryResult {
  text-align: center;
  padding: 30px 0px 10px 0px;
  color: #3d4d6b;
  font-size: 15px;
  font-weight: 500;
}
.queryResultTxt {
  /* flex:0; */
  text-align: center;
  padding: 20px 0px 10px 0px;
  color: #3d4d6b;
  font-size: 15px;
  font-weight: 500;
}
.Pagination {
  flex: 0 0 40px;
  margin: 0 auto;
  width: 80%;
  display: flex;
  justify-content: space-between;
  height: 40px;
  border-radius: 3px;
  align-items: center;
  padding: 0px 15px;
  color: #11254a;
}
.PageNumber {
  margin-left: 10px;
  color: #11254a;
  font-size: 14px;
  cursor: pointer;
}
.footer {
  flex: 0 0 40px;
  margin: 0 auto;
  width: 80%;
  display: flex;
  justify-content: space-between;
  background: #c6cbd1;
  height: 40px;
  border-radius: 3px;
  align-items: center;
  padding: 0px 15px;
  color: #11254a;
}
.pageBtn {
  background: #f3f3f3;
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

/*整理的内联样式 */
.chooseMDisplay {
  margin-right: 8px;
  flex: 1;
}
.timeMDisplay {
  flex: 1;
}

@media (max-width: 1240px) {
  .main {
    height: calc(100% - 120px);
    overflow: auto;
  }
  .content {
    width: 94%;
    display: flex;
    flex-direction: column;
  }
  .list-style {
    display: none;
  }
  .list-style ul:first-child {
    font-size: 13px;
    font-weight: 500;
  }
  .list-style ul:nth-child(n + 2) {
    min-height: 42px;
    height: auto;
  }
  .chooseMDisplay {
    margin-right: 0px;
    flex: 1;
    align-items: center;
    margin-bottom: 10px;
  }
  .timeMDisplay {
    flex: none;
  }
  .list-style-mobile {
    width: 96%;
    margin: 5px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .list-style-mobile ul {
    margin: 5px auto;
    width: 96%;
    background-color: #f5f5f5;
    border-radius: 8px;
  }

  .list-style-mobile ul li {
    display: flex;
    margin: 0 auto;
    width: 94%;
    justify-content: space-around;
    align-items: center;
    min-height: 32px;
    height: auto;
    line-height: 32px;
    border-bottom: 1px solid #fff;
  }

  .list-style-mobile ul li span:nth-child(1) {
    width: 40%;
    text-align: left;
    padding-left: 10px;
    font-size: 15px;
    font-weight: 400;
  }
  .list-style-mobile ul li span:nth-child(2) {
    width: 60%;
    text-align: left;
    word-break: keep-all;
  }
}
@media (max-width: 412px) {
  .main {
    height: calc(100% - 120px);
    overflow: auto;
  }
  .Pagination {
    display: block;
  }
  .Pagination ul:nth-child(1) {
    text-align: center;
  }
  .Pagination ul:nth-child(2) {
    display: flex;
    justify-content: center;
  }
}
</style>
<script>
import SiteM from '../../components/SiteM';
import ShopM from '../../components/ShopM';
import TimeM from '../../components/TimeM';
import dayjs from 'dayjs';

export default {
  name: 'ECoupon',
  data() {
    return {
      totalPages: '0',
      totalCount: '0',
      pagesize: 10,
      currentPageIndex: 1,
      PageNumbers: [],
      dataResult: '',
      TotalConsumption: 0,
      visible: ''
    };
  },
  components: { SiteM, ShopM, TimeM },
  methods: {
    formatDate(res) {
      return dayjs(res).format('YYYY-MM-DD HH:mm:ss');
    },
    dataChange(startTime, endTime, shopList) {
      let self = this;
      let dates = self.getDateDiff(endTime, startTime);
      if (dates > 31) {
        //this.$message.info(dates);
        this.visible = true;
        return;
      }
      if (dates < 0) {
        this.$message.info(this.$t('eVoucherPage.dateRangeIncorrect'));
        return;
      }
      if (!shopList || shopList.length == 0) {
        this.$message.info(this.$t('eVoucherPage.shopIsEmpty'));
        return;
      }
      let _request = {};
      _request.startTime = startTime;
      _request.endTime = endTime;

      _request.shops = shopList;
      _request.pageIndex = self.currentPageIndex - 1;
      _request.pagesize = self.pagesize;
      //console.log(_request);
      ///mtrSearchResult
      this.$refs.time.qloading = true;
      this.$axios
        .post('/EVoucherUsage', _request)
        .then(function (res) {
          self.$refs.time.qloading = false;
          self.dataResult = res.entities;
          var shoplist = JSON.parse(
            self.$store.getters.get_shop_collection_cache
          ).shops;
          var locate = self.$i18n.locale;
          self.dataResult.forEach((d) => {
            let shop = shoplist.find((p) => p.id == d.shopId);
            if (shop) {
              d.shopName = locate == 'en-US' ? shop.nameEN : shop.nameTC;
              d.shopLocation = shop.shopLocation.name;
              d.locationCode = shop.locationCode;
            }
          });
          self.totalCount = res.historyCount;
          self.totalPages = Math.ceil(res.historyCount / self.pagesize);
          self.TotalConsumption = parseFloat(res.totalConsumption).toFixed(2);

          if (self.PageNumbers.length == 0) {
            self.currentPageIndex = 1;
            for (
              let a = self.currentPageIndex - 1;
              a < self.totalPages && a < self.currentPageIndex + 2;
              a++
            ) {
              self.PageNumbers.push(a + 1);
            }
          }
        })
        .catch((err) => {
          // alert(err.statusText)
          self.$refs.time.qloading = false;
          self = null;
          console.log(err);
        });
    },
    exportExcel(obj) {
      //alert(obj.begin +'/' +obj.end +'/' +this.$refs.sitem.SiteList.length +'/' +this.$refs.shopm.ShopList.length);
      let self = this;
      let endTime = obj.end;
      let startTime = obj.begin;
      let shopList = self.$refs.shopm.ShopList;
      let dates = self.getDateDiff(endTime, startTime);
      if (dates > 31) {
        self.visible = true;
        return;
      }
      if (dates < 0) {
        this.$message.info(this.$t('eVoucherPage.dateRangeIncorrect'));
        return;
      }
      if (!shopList || shopList.length == 0) {
        self.$message.info(self.$t('eVoucherPage.shopIsEmpty'));
        return;
      }
      let _request = {};
      _request.startTime = startTime;
      _request.endTime = endTime;

      _request.shops = shopList;
      _request.pageIndex = self.currentPageIndex - 1;
      _request.pagesize = self.pagesize;
      this.$refs.time.eloading = true;
      self.$axios
        .post('/EVoucherUsage/downloadTrsactionCsv', _request)
        .then(function (data) {
          self.$refs.time.eloading = false;
          if (!data) {
            return;
          }
          let url = window.URL.createObjectURL(
            new Blob(['\uFEFF' + data], { type: 'text/csv;charset=utf-8' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', 'eVoucher transaction.csv');
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          //alert(err.statusText)
          self.$refs.time.eloading = false;
          console.log(err);
        });
    },
    queryEvent(obj) {
      this.PageNumbers = [];
      this.currentPageIndex = 1;
      this.dataChange(obj.begin, obj.end, this.$refs.shopm.ShopList);
    },
    search(param, isSearch) {
      if (param == 'home') {
        this.currentPageIndex = 1;
      } else if (param == 'previous') {
        this.currentPageIndex =
          this.currentPageIndex > 1 ? this.currentPageIndex - 1 : 1;
      } else if (param == 'next') {
        this.currentPageIndex =
          this.currentPageIndex + 1 <= this.totalPages
            ? this.currentPageIndex + 1
            : this.currentPageIndex;
      } else if (param == 'end') {
        this.currentPageIndex = this.totalPages;
      } else if (/\d+/.test(param)) {
        this.currentPageIndex = param;
      }
      // set three page number
      this.PageNumbers = [];
      if (this.currentPageIndex > 1) {
        this.PageNumbers.push(this.currentPageIndex - 1);
      }
      this.PageNumbers.push(this.currentPageIndex);
      if (this.currentPageIndex + 1 <= this.totalPages) {
        this.PageNumbers.push(this.currentPageIndex + 1);
      }
      if (!isSearch)
        this.dataChange(
          this.$refs.time.beginDateInput,
          this.$refs.time.endDateInput,
          this.$refs.shopm.ShopList
        );
    },
    getDateDiff(startDate, endDate) {
      var startTime = new Date(
        Date.parse(startDate.replace(/-/g, '/'))
      ).getTime();
      var endTime = new Date(Date.parse(endDate.replace(/-/g, '/'))).getTime();
      var dates = Math.floor(startTime - endTime) / (1000 * 60 * 60 * 24);
      return dates;
    },
    back() {
      this.visible = false;
    }
  },
  created() {
    this.visible = false;
  },
  mounted() {
    this.$refs.sitem.ShopM = this.$refs.shopm;
    this.$refs.shopm.resetSites([]);
  }
};
</script>
